import { Control } from './control';

export class EveryActionForm extends Control {
    public static selector: string = ".every-action-form";

    public emailAddress?: HTMLDivElement;
    public zipCode?: HTMLDivElement;

    private postRenderComplete: boolean = false;
    private static isLoaded: boolean = false;

    constructor(containerElement: Element) {
        super(containerElement);
        this.loadRequiredResources();
    }

    private loadRequiredResources(): void {
        if (EveryActionForm.isLoaded)
            return;

        EveryActionForm.isLoaded = true;

        // attach javascript
        const script: HTMLScriptElement = document.createElement("script");
        script.lang = "JavaScript";
        script.src = `https\://static.everyaction.com/ea-actiontag/at.js`;
        script.crossOrigin = "anonymous";
        script.defer = true;
        document.body.appendChild(script);

        // attach post load event
        globalThis.nvtag_callbacks ??= {};
        globalThis.nvtag_callbacks.postRender ??= [];
        globalThis.nvtag_callbacks.postRender.push(() =>
            EveryActionForm.getInstances<EveryActionForm>()
                .filter(emailSignup => emailSignup.container.classList.contains("email-signup"))
                .forEach(emailSignup => emailSignup.updateOnPostLoad())
        );
    }

    public updateOnPostLoad(): void {
        if (this.postRenderComplete)
            return;

        this.emailAddress = this.container.getElementsByClassName("EmailAddress")[0] as HTMLDivElement;
        this.zipCode = this.container.getElementsByClassName("PostalCode")[0] as HTMLDivElement;

        if (!this.emailAddress || !this.zipCode)
            return;

        this.emailAddress.parentElement?.insertBefore(this.emailAddress, this.zipCode);
        this.postRenderComplete = true;
    }
}
